import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";


export const GET_PAYMENT_ESTIMATION_DATA_LISTS = "GET_PAYMENT_ESTIMATION_DATA_LISTS";

export const service = async () => {
    const options: object = {
        url: `/Api/PayerGroup/GetPaymentEstimationDataLists`,
        method: 'GET',  
    }; 

    const response = callMvcApi(options);
    return response;
};

const mockData = () => {
    return [];
};

const mock = () => {
    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockData());
        }, 2000);
    });
    return promise;
};

register(GET_PAYMENT_ESTIMATION_DATA_LISTS, service, mock);